import React from 'react';
import {DEVICE, useScreenResize} from '@chekin/guestapp-ui-kit';
import {SelectRefType} from '@guestapp/old-ui-kit';
import {
  QueriedSearchingSelect,
  QueriedSearchingSelectProps,
} from './QueriedSearchingSelect';
import {MobileQueriedSearchingSelect} from './MobileQueriedSearchingSelect';

type AdaptiveSearchingSelectProps<T, V, L> = QueriedSearchingSelectProps<T, V, L> & {
  target?: (isOpen: boolean, toggle: () => void) => React.ReactNode;
};

const AdaptiveSearchingSelectInternal = <T, V, L>(
  {...props}: AdaptiveSearchingSelectProps<T, V, L>,
  ref: React.ForwardedRef<SelectRefType<T, V, L>>,
) => {
  const {isMatch: isMobileMode} = useScreenResize(DEVICE.laptop);

  if (isMobileMode) {
    return <MobileQueriedSearchingSelect ref={ref} {...props} />;
  }

  return <QueriedSearchingSelect ref={ref} {...props} />;
};

const AdaptiveQueriedSearchingSelect = React.forwardRef(
  AdaptiveSearchingSelectInternal,
) as <T, V = string, L = string>(
  props: AdaptiveSearchingSelectProps<T, V, L> & {
    ref?: React.ForwardedRef<SelectRefType<T, V, L>>;
  },
) => ReturnType<typeof AdaptiveSearchingSelectInternal>;

export {AdaptiveQueriedSearchingSelect};
